import { createAction } from 'redux-actions';

export const init = createAction('AUTH/INIT', (options, endpoints) => ({
  endpoints,
  options,
}));
export const store = createAction('AUTH/STORE', (result) => ({
  isAuthenticated: false,
  role: null,
  token: null,
  user: null,
  ...result,
}));

export default {
  init,
  store,
};
